import type { CustomEmoji } from "@circle-react-uikit/EmojiPickerV3/data/utils";

import { DEFAULT_ICON } from "../FormEmojiPickerV3/constants";

type IconIdentity = Pick<CustomEmoji, "emoji_type" | "identifier">;

interface IsDefaultIconOptions {
  customEmoji?: IconIdentity | null;
  defaultIcon: IconIdentity | null;
  isRecordDefaultIcon?: boolean;
}

export const isDefaultIcon = ({
  customEmoji,
  defaultIcon,
  isRecordDefaultIcon,
}: IsDefaultIconOptions): boolean => {
  if (!defaultIcon) return false;

  if (customEmoji) {
    return (
      customEmoji.emoji_type === defaultIcon.emoji_type &&
      customEmoji.identifier === defaultIcon.identifier
    );
  }

  return (
    isRecordDefaultIcon === true &&
    defaultIcon.emoji_type === DEFAULT_ICON.emoji_type &&
    defaultIcon.identifier === DEFAULT_ICON.identifier
  );
};
